module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#user",
      toString: function () {
        return this.url;
      }
    }